module.exports = require("./pluginPropView.vue");